import API from '../dataApi';

// -- Accounting: Ledger Groups (read-only — system-defined) -------------------
export const getAccountingLedgerGroups = (derasarId) => API.get('/ledger-groups', { params: { derasarId } });
